import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const FETCH_CLAIM_STATUSES = 'FETCH_CLAIM_STATUSES';
export const FETCH_CLAIM_STATUSES_SUCCESS = 'FETCH_CLAIM_STATUSES_SUCCESS';
export const FETCH_CLAIM_STATUSES_FAIL = 'FETCH_CLAIM_STATUSES_FAIL';
export const CLEAR_CLAIM_STATUSES = 'CLEAR_CLAIM_STATUSES';
export const CREATE_CLAIM_STATUS = 'CREATE_CLAIM_STATUS';
export const UPDATE_CLAIM_STATUS = 'UPDATE_CLAIM_STATUS';
export const UPDATE_CLAIM_STATUS_SUCCESS = 'UPDATE_CLAIM_STATUS_SUCCESS';
export const UPDATE_CLAIM_STATUS_FAIL = 'UPDATE_CLAIM_STATUS_FAIL';

// Reducer
export default function claimStatusesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_CLAIM_STATUSES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_CLAIM_STATUSES_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_CLAIM_STATUSES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_CLAIM_STATUSES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case UPDATE_CLAIM_STATUS_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchClaimStatuses(payload) {
  return { type: FETCH_CLAIM_STATUSES, payload };
}

export function fetchClaimStatusesSuccess(payload) {
  return { type: FETCH_CLAIM_STATUSES_SUCCESS, payload };
}

export function fetchClaimStatusesFail(payload) {
  return { type: FETCH_CLAIM_STATUSES_FAIL, payload };
}

export function clearClaimStatuses(payload) {
  return { type: CLEAR_CLAIM_STATUSES, payload };
}

export function updateClaimStatus(payload) {
  return { type: UPDATE_CLAIM_STATUS, payload };
}

export function updateClaimStatusSuccess(payload) {
  return { type: UPDATE_CLAIM_STATUS_SUCCESS, payload };
}

export function updateClaimStatusFail(payload) {
  return { type: UPDATE_CLAIM_STATUS_FAIL, payload };
}

// Requests

let abort;

export function requestFetchClaimStatuses(payload) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = payload
    ? abortableCallApi(`claim_md/claim_statuses/?limit=${payload.limit}&offset=${payload.offset}`)
    : abortableCallApi('claim_md/claim_statuses/');
  abort = request.abort;
  return request.res;
}

export function requestSearchClaimStatuses({ limit, offset, filters }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('claim_md/claim_statuses/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Status',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestUpdateClaimStatus(payload) {
  return callApi('claim_md/claim_statuses/', 'PATCH', payload);
}

// Sagas
function* fetchClaimStatusesSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchClaimStatuses, action.payload)
      : yield call(requestFetchClaimStatuses, action.payload);
    yield put(fetchClaimStatusesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchClaimStatusesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* updateClaimStatusSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateClaimStatus, values);
    yield put(updateClaimStatusSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Document Category successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updateClaimStatusFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* claimStatusesSaga() {
  yield takeLatest(FETCH_CLAIM_STATUSES, fetchClaimStatusesSaga);
  yield takeEvery(UPDATE_CLAIM_STATUS, updateClaimStatusSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/claimStatuses.js